/* eslint-disable import/prefer-default-export */
import { AnyAction } from 'redux';

// Data Layer
import { ServerResponse } from 'data-layer-cr/dist/models';
import { setRequestStatus } from 'data-layer-cr/dist/network';

// Redux
import { AppThunk, AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';
import {
  setCurrentCarGeneralData,
  updateHasInsuredRange,
  updateInsuredValues,
} from '../slice/carSlice';

// Local Imports
import { REQUEST_INSURED_VALUES } from '../requestIdentifiers';
import CarItem from '../../../models/helperTypes/CarItem';
import InsuredValueRequest from '../../../models/requestTypes/InsuredValueRequest';
import InsuredValue from '../../../models/responseTypes/InsuredValue';
import processRequest from '../../../services/processRequest';

/**
 * Updates general car data
 *
 * @param data - The captured car data.
 */
export const updateGeneralData =
  (data: CarItem): AppThunk =>
  (dispatch): void => {
    dispatch(setCurrentCarGeneralData(data));
  };

/**
 * Requests insured car values for provided model, car, year
 *
 * @param carYear - Year of the car
 * @param carModel - Car Model
 * @param carBrand - Car Brand
 */

export const getInsuredValueRange =
  (carBrand: string, carModel: string, carYear: number): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_INSURED_VALUES, 'requesting'));
    try {
      const payload: InsuredValueRequest = {
        carBrand,
        carModel,
        carYear,
      };

      const result = await processRequest<ServerResponse<InsuredValue>>({
        method: 'POST',
        data: payload,
        url: 'calculations/insurablevalue',
        supressError: true,
      });

      /** Updates insured values and sets the range limit needed for the form */
      dispatch(updateInsuredValues(result.data));
      dispatch(updateHasInsuredRange(true));

      return dispatch(setRequestStatus(REQUEST_INSURED_VALUES, 'success'));
    } catch (e) {
      /** It won't be required in the form to advance */
      dispatch(updateHasInsuredRange(false));
      return dispatch(setRequestStatus(REQUEST_INSURED_VALUES, 'failure'));
    }
  };
